import { Component, OnInit, OnChanges, OnDestroy, Input, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { IFlag } from '../../../shared/flag/flag.model';
import { Observable, Subject } from 'rxjs';
import { FlagService } from '../../../shared/flag/flag.service';
import { takeUntil } from 'rxjs/operators';
import { MapElement } from '../../../shared/map/map-element.model';
import { Point } from 'geojson';
import { BaseComponent } from '../../../components/general/base/base.component';


/**
 * Toggles the flag for the feature (marker) given as input.
 * Gets and sets the flag status directly with flagService.
 */
@Component({
  selector: 'qm-flag-action',
  templateUrl: './flag-action.component.html',
  styleUrls: ['./flag-action.component.scss']
})
export class FlagActionComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {

  @Input() private feature: MapElement<Point>;
  @Input() private userName: string;
  @Input() private uniq: string;

  private flags$: Observable<IFlag[]>;
  public flag: boolean = false;

  /**
   * Subscription manager
   * @type {Subject<any>}
   */
  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(
    private flagService: FlagService,
    private cdr: ChangeDetectorRef) {
    super();
    this.name = 'FlagActionComponent';
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    /**
     * When parent component is switched directly
     * from marker to marker, the element actions is not re-initialised,
     * but only given new inputs -> update flags$ to current feature in ngOnChanges
     */
    if (changes.feature.isFirstChange() || changes.feature.currentValue.id !== changes.feature.previousValue.id) {
      this.flags$ = this.flagService.flags$;
      this.flags$.pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((flags) => {
          const foundFlag = flags.find((f: IFlag) => {
            //// canvas vs. markerlayers behave differently
            return (f.targetObjectId === ''+this.feature.properties[this.uniq] || f.targetObjectId === this.feature.id.toString());
          });
          this.flag = foundFlag !== undefined;
          this.cdr.detectChanges();
        });
      }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public async toggleFlag() {
    console.log('toggleflag' + JSON.stringify(this.flag));
    const flags = await this.flagService.filter({
      targetObjectId: this.feature.properties[this.feature.layer.metadata.uniqueBy]
    });
    if (flags.isOk) {
      if (flags.data.length <= 0) {
        const flag: IFlag = new IFlag();
        flag.targetObjectId = this.feature.properties[this.feature.layer.metadata.uniqueBy].toString();
        flag.targetObjectType = 'mapObject';
        flag.global = false;
        flag.layerId = this.feature.layer.id;
        flag.geometry = this.feature.geometry;
        flag.userId = this.userName;
        console.log('ADD FLAG');
        const addd = await this.flagService.create(flag);
      } else {
        console.log('REMOVE FLAG 2');
        const rem = await this.flagService.remove(flags.data[0]);
      }
    } else {
      console.log('ToggleFlag, should do something, but did not found the selected element');
    }
    this.cdr.markForCheck();
  }
}
